import React from 'react';
import { Badge } from 'react-bootstrap';
import {
  FaUserShield, FaLink, FaIdCard
} from 'react-icons/fa';
import GenericCrudPage from '../components/GenericCrudPage';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const validateRoleForm = (form) => {
  const errors = {};
  if (!form.roleName.trim()) errors.roleName = "Role name is required";
  if (form.roleName.length > 100) errors.roleName = "Role name must be less than 100 characters";
  if (form.navigatingURL && form.navigatingURL.length > 200) errors.navigatingURL = "Navigating URL must be less than 200 characters";
  return errors;
};

const roleConfig = {
  baseUrl: BASE_URL,
  endpoints: {
    fetch: '/master/getRole',
    save: '/master/saveRole',
    update: '/master/updateRole',
    delete: '/master/deleteRole'
  },
  validateForm: validateRoleForm,
  initialFormState: {
    roleName: "", 
    navigatingURL: "", 
    isActive: 1, 
    user: ""
  },
  entityName: 'Role'
};

const formFields = [
  { name: "roleName", label: "Role Name", icon: FaUserShield, required: true },
  { name: "navigatingURL", label: "Navigating URL", icon: FaLink, placeholder: "/admin/dashboard" }
];

const tableColumns = [
  {
    key: 'exRoleName',
    label: 'Role Name',
    sortable: true,
    render: (role) => (
      <div>
        <div className="fw-bold">{role.exRoleName}</div>
        {role.exNavigatingURL && (
          <div className="text-muted small font-monospace">{role.exNavigatingURL}</div>
        )}
      </div>
    )
  },
  {
    key: 'id',
    label: 'Role ID',
    sortable: true,
    render: (role) => (
      <Badge bg="secondary-subtle" text="secondary-emphasis" className="font-monospace">
        #{role.id}
      </Badge>
    )
  }
];

const csvHeaders = [
  { key: 'id', label: 'ID' },
  { key: 'exRoleName', label: 'Role Name' },
  { key: 'exNavigatingURL', label: 'Navigating URL' },
  { key: 'exIsActive', label: 'Status' }
];

const transformPayload = (form, editId, userId) => ({
  exRoleName: form.roleName.trim(),
  exNavigatingURL: form.navigatingURL.trim(),
  exIsActive: form.isActive,
  user: userId || 1,
  ...(editId && { id: editId })
});

const transformToForm = (role) => ({
  roleName: role.exRoleName || "",
  navigatingURL: role.exNavigatingURL || "",
  isActive: role.exIsActive ? 1 : 0,
  user: role.user || ""
});

const getViewFields = (role) => {
  if (!role) return [];
  return [
    { label: "Role ID", value: `#${role.id}`, icon: FaIdCard },
    { label: "Role Name", value: role.exRoleName, icon: FaUserShield },
    { label: "Navigating URL", value: role.exNavigatingURL || "Not specified", icon: FaLink, fullWidth: true }
  ];
};

export default function RolePage() {
  return (
    <GenericCrudPage
      title="Roles"
      config={roleConfig}
      formFields={formFields}
      tableColumns={tableColumns}
      emptyIcon={FaUserShield}
      searchPlaceholder="Search by role name, URL..."
      csvHeaders={csvHeaders}
      csvFilename="roles_export.csv"
      transformPayload={transformPayload}
      transformToForm={transformToForm}
      getViewFields={getViewFields}
      dataKey="role"
    />
  );
}